import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("auth_token") || "");
  const [loading, setLoading] = useState(true);

  const setAuth = useCallback((newToken, userData) => {
    if (newToken) {
      localStorage.setItem("auth_token", newToken);
      setToken(newToken);
      setUser(userData);
    } else {
      localStorage.removeItem("auth_token");
      setToken("");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setUser(res.data.user))
        .catch(() => setAuth(null, null))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token, setAuth]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    setAuth(res.data.token, res.data.user);
    return res.data;
  };

  const register = async (email, password, pageId) => {
    const res = await axios.post(`${API}/auth/register`, { email, password, page_id: pageId || null });
    setAuth(res.data.token, res.data.user);
    return res.data;
  };

  const logout = () => setAuth(null, null);

  const linkPage = async (pageId) => {
    if (!token) return;
    await axios.post(`${API}/pages/${pageId}/claim`, {}, { headers: { Authorization: `Bearer ${token}` } });
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, linkPage, setAuth, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
